import {ErrorCode} from './ErrorCode';

export const errorMessages: Record<ErrorCode, string> = {
  [ErrorCode.UNKNOWN]: 'An unknown error occurred',
  [ErrorCode.NETWORK_ERROR]: 'A network error occurred',
  [ErrorCode.VALIDATION_ERROR]: 'A validation error occurred',
  [ErrorCode.UNAUTHENTICATED]: 'Invalid username / password',
  [ErrorCode.EMPTY_INPUT_VALIDATION]: 'Please enter a value',
  [ErrorCode.EMPTY_SELECT_VALIDATION]: 'Please select an option',
  [ErrorCode.INVALID_BULK_UPLOAD]:
      'Invalid bulk upload content, if you need assistance with uploading data please contact us on {{supportEmail}}',
  [ErrorCode.LOGGED_OUT]: 'You have been logged out',
  [ErrorCode.INVALID_PERMISSIONS]: 'You do not have permission to perform this action',
  [ErrorCode.BULK_UPLOAD_PARSE_ERROR_GENERIC]: 'An error occurred while parsing the bulk upload file',
  [ErrorCode.BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS]: 'The columns in the file do not match the expected columns',
  [ErrorCode.BULK_UPLOAD_MAX_RECORD_SIZE]: 'One or more fields in the file are too large',
  [ErrorCode.BULK_UPLOAD_INCONSISTENT_COLUMNS]: 'The columns in the file are inconsistent, all columns must follow the same format',
}
